import { Chip} from '@mui/material';
import { LegalDocumentTypeEnums } from '../types/referenceData/legalDocumentTypeEnums';


export const GetSearchDocumentTypeTag = (typeId:  number) => {

    let type = "OCPF Document";
    switch (typeId) {
        case LegalDocumentTypeEnums.AdvisoryOpinion:
            type = "Advisory Opinion";
            break;
        case LegalDocumentTypeEnums.GuidanceLetter:
            type = "Guidance Letter";
            break;
        case LegalDocumentTypeEnums.InterpretativeBulletin:
            type = "Interpretative Bulletin";
            break;
        case LegalDocumentTypeEnums.Memoranda:
            type = "OCPF Memoranda";
            break;
        case LegalDocumentTypeEnums.Law:
            type = "Chapter 55 Law Section";
            break; 
        case LegalDocumentTypeEnums.Regulation:
            type = "Regulation";
            break;
        case LegalDocumentTypeEnums.ResolutionLetter:
            type = "Resolution Letter";
            break; 
        case LegalDocumentTypeEnums.AO:
            type = "AGO Action on Referral";
            break;
        case 100:
            type = "Question/Answer";
            break;
        case 50:
            type = "OCPF Topic";
            break;
        case 60:
            type = "OCPF Guide";
            break;
        case 61:
            type = "Fact Sheet";
            break;
        case 62:
            type = "OCPF Study";
            break;
        case 63:
            type = "OCPF Newsletter";
            break;
        case 64:
            type = "OCPF Form";
            break;      
        case 65:
            type = "Help Video";
            break; 
        case 66:
            type = "Press Release";
            break;
        case 67:
            type = "News Post";
            break;  
        case 68:
            type = "Clerk Checking In";
            break;                       
        default:
            type = "OCPF Document";
    }

    return (
        <Chip label={type} size="small" sx={{fontSize: "0.75rem"}} />
    )
};